import * as React from 'react';

import type { LaborStatisticsPerLocationParsed, IndividualLaborStatisticsParsed } from 'ab-viewModels/scheduleBoardLaborStatistics.viewModel';

import { SB_STATISTIC_WIDTH } from 'af-constants/values';

import IndividualLaborStatistics from 'af-components/LaborStatistics/IndividualLaborStatistics';

import MaterialCostStatistics from './MaterialCostStatistics';

interface OwnProps {
	laborStatisticsPerLocation: LaborStatisticsPerLocationParsed;
	totalLaborStatistics?: IndividualLaborStatisticsParsed;
	offset?: number;
	isWeekly?: boolean;
}

type Props = OwnProps;

export default class LaborStatisticsPerLocation extends React.PureComponent<Props> {
	static defaultProps: Partial<Props> = {
		laborStatisticsPerLocation: {} as LaborStatisticsPerLocationParsed,
		offset: 0,
		isWeekly: false,
	};

	render() {
		const { laborStatisticsPerLocation, totalLaborStatistics, offset, isWeekly } = this.props;

		let className = 'statistics-carousel';
		className = isWeekly ? `${className} statistics-carousel--weekly` : className;

		return (
			<div className={className} style={{ transform: `translateX(${-SB_STATISTIC_WIDTH * (offset ?? 0)}px)` }}>
				{
					Object.entries(laborStatisticsPerLocation).map(([locationNickname, laborStatisticsData]) => laborStatisticsData.hidden ? null : (
						<IndividualLaborStatistics
							key={locationNickname}
							label={locationNickname}
							laborStatistics={laborStatisticsData}
						/>
					))
				}
				{
					totalLaborStatistics &&
					<IndividualLaborStatistics
						label="Total"
						laborStatistics={totalLaborStatistics}
					/>
				}
				<MaterialCostStatistics
					label="Materials"
					laborStatistics={totalLaborStatistics}
				/>
			</div>
		);
	}
}
